<template>
  <div>
    <h2>{{ $t('views.endusers.changetracking.title') }}</h2>

    <section v-for="section in endUserSections" :key="section.endUserId" class="mb-4">
      <h3>Tenant {{ section.tenantName }}</h3>
      <entity-changetracking-table :entityBy="entityBy(section.endUserId)" :storeModule="storeModule"/>
    </section>
  </div>
</template>

<script>
import { STOREMODULE_ENDPOINTMODULE_MAP } from '@/assets/js/config/server'

import MixinEntityBase from '@/components/mixins/EntityBase'
import EntityChangetrackingTable from '@/components/entity/ChangetrackingTable'
import MixinEndUserSections from '@/views/EndUsers/_mixins/endUserSections'

export default {
  name: 'EndUsers.ChangeTracking',
  mixins: [MixinEntityBase, MixinEndUserSections],
  components: {
    EntityChangetrackingTable
  },
  computed: {
    storeModule () {
      return STOREMODULE_ENDPOINTMODULE_MAP.customer
    }
  },
  methods: {
    entityBy (endUserId) {
      return {
        name: 'EndUser',
        id: endUserId
      }
    }
  }
}
</script>

<style lang="scss"></style>

